import type { Config as Interface } from "../../design/types";

export class Config implements Interface {
    id: string;
    anthropicApiKey?: string;
    anthropicModel?: string;
    [key: string]: unknown;

    constructor(id = 'local') {
        this.id = id;
        // Read from environment variables (Vite exposes VITE_ prefixed vars)
        const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
        this.anthropicApiKey = env?.VITE_ANTHROPIC_API_KEY;
        this.anthropicModel = env?.VITE_ANTHROPIC_MODEL || 'claude-haiku-4-5-20251001';
    }
}